import axios from '../index'
///create crn
export default { 
    createSesion (payload) {
        return axios.post('/academico-sesiones/store', payload)
    },

    //update crn
    updateSesion (payload) {
        return axios.post('/academico-sesiones/update', payload)
    },

    //delete crn /academico-sesiones/delete/id
    deleteSesion (payload) {
        return axios.post('/academico-sesiones/delete',payload)
    },

    //delete crn /academico-sesiones/listado
    listadoSesiones (institucionId, params) {
        return axios.get('/academico-sesiones/list/' + institucionId, {
            params
        })
    },
    postSubirExcel(id_sesion,formData){
        return axios.post('/academico-sesiones/uploadContentCodigoSession/' + id_sesion, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    postAceptarExcel(id_sesion,formData){
        return axios.post('/academico-sesiones/save_academico_sessiones/' + id_sesion, formData)
    },
    getAllAulas(){
        return axios.get('/academico-sesiones/aulasAll')
    }
    
}